<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('martSale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('martSale.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'order' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex ts-space-x-3">
            <label class="mt-2">Status : </label>
            <a-select
              v-model="is_paid"
              :options="isPaidStatusList"
              style="width: 150px"
            ></a-select>

            <a-range-picker
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
              style="width: 300px"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block ml-2"
            />
            <!-- <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button> -->
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'stock_out_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.invoice_no }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.order_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer ? record.customer.customer_name : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.sub_total) }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ record.discount_rate }}
              {{ record.discount_type }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.discount) }}
            </td>
            <!-- <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.vat_amount) }}
            </td> -->
            <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.grand_total) }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.paid_in_usd) }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ record.paid_in_riel | format_number }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ record.paid_in_thb | format_number }}
            </td>
            <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.paid_in_coupon) }}
            </td>
            <!-- <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.paid_in_credit_card) }}
            </td> -->
            <td class="ts-whitespace-no-wrap text-right">
              {{
                record.bank_transfer_riel > 0
                  ? formatPrice(record.bank_transfer_riel) + ' ៛ '
                  : ''
              }}
              {{
                record.bank_transfer_riel > 0 && record.bank_transfer > 0
                  ? '|'
                  : ''
              }}
              {{
                record.bank_transfer > 0
                  ? formatPrice(record.bank_transfer) + ' $'
                  : ''
              }}
            </td>
            <!-- <td class="ts-whitespace-no-wrap text-right">
              {{ formatPrice(record.paid_by_cheque) }}
            </td> -->
            <td class="ts-whitespace-no-wrap text-center">
              <span v-if="!record.is_paid" class="label label-danger"
                >Unpaid</span
              >
              <span v-else class="label label-success">Paid</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.employee_name_en
                    : null
                  : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <b-dropdown
                size="xs"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
                v-tooltip="$t('pdf')"
              >
                <template slot="button-content">
                  <i class="fas fa-file-pdf text-danger"></i>
                </template>
                <b-dropdown-item @click="pdfView(record, 'kh')">
                  {{ $t('martSale.templateAsKh') }}
                </b-dropdown-item>
                <b-dropdown-item @click="pdfView(record, 'en')">
                  {{ $t('martSale.templateAsEn') }}
                </b-dropdown-item>
              </b-dropdown>
              <a
                href="#"
                v-tooltip="$t('delete')"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <pdf-preview
        v-model="pdf_view"
        :invoice-id="invoiceId"
        :template="template"
        @cancel="value => (pdf_view = value)"
      />
    </ts-card>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import PdfPreview from './components/pdf-preview'
import Reason from './components/reason-delete'
import moment from 'moment'

export default {
  name: 'martSale',
  components: {
    PdfPreview
  },
  data() {
    return {
      visible: false,
      loading: false,
      pdf_view: false,
      invoiceId: null,
      template: '',
      model: {
        deleted_reason: null
      },
      errors: new Errors(),
      rangeDate: [moment().add('days', -7), moment()],
      isPaidStatusList: [
        { value: '', label: 'All' },
        { value: 'true', label: 'Paid' },
        { value: 'false', label: 'Unpaid' }
      ]
    }
  },
  created() {
    PageOptions.pageEmpty = false
    this.fetchData()
  },
  filters: {
    format_number(value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return '-'
    }
  },
  computed: {
    ...mapState('martSale/order', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.martSale.order.search
      },
      set(newValue) {
        this.$store.commit('martSale/order/SET_SEARCH', newValue)
        this.$store.commit('martSale/order/RESET_CURRENT_PAGE')
      }
    },
    is_paid: {
      get() {
        return this.$store.state.martSale.order.is_paid
      },
      set(newValue) {
        this.$store.commit('martSale/order/SET_IS_PAID', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('martSale.branch') },
        {
          name: this.$t('martSale.invoiceNo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('martSale.orderNo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('martSale.numberCustomer')
        },
        {
          name: this.$t('martSale.subtotal'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.discountRate'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.discount'),
          style: 'text-align:right'
        },
        // {
        //   name: this.$t('martSale.vatAmount'),
        //   style: 'text-align:right'
        // },
        {
          name: this.$t('martSale.grandTotal'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.paidInUsd'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.paidInRiel'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.paidInThb'),
          style: 'text-align:right'
        },
        {
          name: this.$t('martSale.paidInCoupon'),
          style: 'text-align:right'
        },
        // {
        //   name: this.$t('martSale.paidInCreditCard'),
        //   style: 'text-align:right'
        // },
        {
          name: this.$t('martSale.paidInBankTransfer'),
          style: 'text-align:right'
        },
        // {
        //   name: this.$t('martSale.paidInCheque'),
        //   style: 'text-align:right'
        // },
        { name: this.$t('martSale.status'), style: 'text-align:center' },
        { name: this.$t('martSale.cashier') },
        { name: this.$t('actions'), style: 'text-align:center; width:3%' }
      ]
    }
  },
  methods: {
    ...mapActions('martSale/order', ['destroy']),
    formatPrice(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return '-'
    },
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'martSale/order/fetch',
          Object.assign({}, { branch_id: this.branch_id }, attributes)
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('martSale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.stock_out_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    show(record) {
      this.$store.commit('martSale/order/SET_SHOW_DATA', record)
      this.$router.push({
        name: 'invoice-show',
        params: { id: record.stock_out_id }
      })
    },
    pdfView(record, template) {
      this.invoiceId = record.stock_out_id
      this.template = template
      this.pdf_view = true
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'martSale/order/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'martSale/order/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    is_paid: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('martSale/order/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 10px 5px !important;
}
.table thead tr th {
  padding: 10px 5px !important;
}
</style>
